<template>
    <div class="BankDetails">
        <el-card class="box-card" v-loading="is_bank_details_loading">
            <el-collapse v-model="bank_details_collapse" accordion>
                <el-collapse-item name="1">
                    <template slot="title">
                        <div class="flex">
                            <img src="../assets/images/myAccount/bank_details.png" style="width: 25px;">
                            <div class="label-md-bold-black left-margin-10">Bank Details</div>
                        </div>
                    </template>

                    <div style="padding: 0 20px;">
                        <el-row :gutter="15">
                            <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                                <div class="form-group" :class="{'not-empty': account_number.length , 'form-group--error': $v.account_number.$error }">
                                    <label class="input-label-bold-gray">Account number</label>&nbsp;<span class="required-field">*</span>

                                    <input type="text" class="custom-input" placeholder="Account number" v-model="account_number" @input="setAccountNumber($event.target.value)">
                                </div>

                                <div style="color: red; font-size: 0.75em;" v-if="validate_account_number">
                                    Please enter numbers only
                                </div>

                                <div style="color: red; font-size: 0.75em;" v-if="account_number_not_matching">
                                    Account number not matching
                                </div>

                                <div class="error" v-if="!$v.account_number.required">
                                    Field is required
                                </div>
                            </el-col>

                            <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                                <div class="form-group" :class="{'not-empty': reenter_account_number.length , 'form-group--error': $v.reenter_account_number.$error }">
                                    <label class="input-label-bold-gray">Renter account number</label>&nbsp;<span class="required-field">*</span>
                                    <input type="text" class="custom-input" placeholder="Renter account number" v-model="reenter_account_number" @input="setReEnterAccountNumber($event.target.value)">
                                </div>

                                <div style="color: red; font-size: 0.75em;" v-if="validate_reentered_account_number">
                                    Please enter numbers only
                                </div>

                                <div style="color: red; font-size: 0.75em;" v-if="reentered_account_number_not_matching">
                                    Account number not matching
                                </div>

                                <div class="error" v-if="!$v.reenter_account_number.required">
                                    Field is required
                                </div>
                            </el-col>
                        </el-row>

                        <el-row :gutter="15" class="top-margin-10">
                            <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                                <div class="form-group" :class="{'not-empty': ifsc.length , 'form-group--error': $v.ifsc.$error }">
                                    <label class="input-label-bold-gray">IFSC</label>&nbsp;<span class="required-field">*</span>
                                    <input type="text" class="custom-input" placeholder="IFSC" v-model="ifsc" @input="setIFSC($event.target.value)">
                                </div>

                                <div style="color: red; font-size: 0.75em;" v-if="validate_ifsc">
                                    Please enter 11 digit alphabetic characters only
                                </div>
                                <div class="error" v-if="!$v.ifsc.required">
                                    Field is required
                                </div>
                            </el-col>

                            <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                                <div class="form-group" :class="{'not-empty': bank_name.length , 'form-group--error': $v.bank_name.$error }">
                                    <label class="input-label-bold-gray">Bank name</label>&nbsp;<span class="required-field">*</span>
                                    <input type="text" class="custom-input" placeholder="Bank name" v-model="bank_name" @input="setBankName($event.target.value)">
                                </div>

                                <div style="color: red; font-size: 0.75em;" v-if="validate_bank_name">
                                    Please enter alphabetic characters only
                                </div>
                                <div class="error" v-if="!$v.bank_name.required">
                                    Field is required
                                </div>
                            </el-col>
                        </el-row>

                        <el-row :gutter="15" class="top-margin-10">
                            <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                                <div class="form-group" :class="{'not-empty': beneficiary_name.length , 'form-group--error': $v.beneficiary_name.$error }">
                                    <label class="input-label-bold-gray">Beneficiary name</label>&nbsp;<span class="required-field">*</span>
                                    <input type="text" class="custom-input" placeholder="Beneficiary name" v-model="beneficiary_name" @input="setBeneficiaryName($event.target.value)">
                                </div>

                                <div style="color: red; font-size: 0.75em;" v-if="validate_beneficiary_name">
                                    Please enter alphabetic characters only
                                </div>
                                <div class="error" v-if="!$v.beneficiary_name.required">
                                    Field is required
                                </div>
                            </el-col>

                            <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                                <div class="form-group" :class="{'not-empty': mobile_number.length , 'form-group--error': $v.mobile_number.$error }">
                                    <label class="input-label-bold-gray">Mobile number</label>&nbsp;<span class="required-field">*</span>
                                    <input type="text" class="custom-input" placeholder="Mobile number" v-model="mobile_number" @input="setMobileNumber($event.target.value)">
                                </div>

                                <div style="color: red; font-size: 0.75em;" v-if="validate_mobile_number">
                                    Please enter 10 digit numbers only
                                </div>
                                <div class="error" v-if="!$v.mobile_number.required">
                                    Field is required
                                </div>
                            </el-col>
                        </el-row>

                        <div class="text-right save-btn-section top-margin-20">
                            <el-button type="primary custom-btn" :loading="is_bank_details_save_progress" @click="saveBilingDetails()">Save</el-button>
                        </div>
                    </div>
                </el-collapse-item>
            </el-collapse>
        </el-card>
    </div>
</template>

<script>
import { serverAddr } from "../networkConfig";
import { required } from "vuelidate/lib/validators";
import CripNotice from "crip-vue-notice";

export default {
    name: 'BankDetails',
    data() {
        return {
            bank_details_collapse: '1',
            account_number: '',
            validate_account_number: false,
            account_number_not_matching: false,
            reenter_account_number: '',
            validate_reentered_account_number: false,
            reentered_account_number_not_matching: false,
            ifsc: '',
            validate_ifsc: false,
            bank_name: '',
            validate_bank_name: false,
            beneficiary_name: '',
            validate_beneficiary_name: false,
            mobile_number: '',
            validate_mobile_number: false,
            is_bank_details_save_progress: false,
            is_bank_details_loading: false
        }
    },

    validations: {
        account_number: {
            required
        },
        reenter_account_number: {
            required
        },
        ifsc: {
            required
        },
        bank_name: {
            required
        },
        beneficiary_name: {
            required
        },
        mobile_number: {
            required
        }
    },

    mounted() {

        // // checked if object stored in vue store then retrieved it
        if(Object.keys(this.getBankDetails).length){
            this.account_number = this.getBankDetails.account_number ? this.getBankDetails.account_number : '';
            this.reenter_account_number = this.getBankDetails.account_number ? this.getBankDetails.account_number : '';
            this.ifsc = this.getBankDetails.ifsc_code ? this.getBankDetails.ifsc_code : '';
            this.bank_name = this.getBankDetails.bank_name ? this.getBankDetails.bank_name : '';
            this.beneficiary_name = this.getBankDetails.beneficiary_name ? this.getBankDetails.beneficiary_name : '';
            this.mobile_number = this.getBankDetails.mobile ? this.getBankDetails.mobile : '';
        }else{
            // otherwise fetch detail from api
            this.getBankDetailsNetworkCallBack();
        }
    },

    methods: {
        setAccountNumber(value){
            if(value){
                // this.account_number = value.trim();
                this.$v.account_number.$touch();
                var letters = /^([0-9])+$/;

                if(this.account_number.match(letters)) {
                    this.validate_account_number = false;
                    this.account_number_not_matching = false;
                    if(this.reenter_account_number && !this.validate_reentered_account_number && this.account_number != this.reenter_account_number){
                        this.account_number_not_matching = true;
                    }else{
                        this.account_number_not_matching = false;
                        this.reentered_account_number_not_matching = false;
                    }
                } else if(this.account_number != "") {
                    this.validate_account_number = true;
                    this.account_number_not_matching = false;
                }
            }
        },

        setReEnterAccountNumber(value){
            if(value){
                // this.account_number = value.trim();
                this.$v.reenter_account_number.$touch();
                var letters = /^([0-9])+$/;
                // var letters = /^[a-zA-Z0-9_ .,]+$/;
                if(this.reenter_account_number.match(letters)) {
                    this.validate_reentered_account_number = false;
                    this.reentered_account_number_not_matching = false;

                    if(this.account_number && !this.validate_reentered_account_number && this.account_number != this.reenter_account_number){
                        this.reentered_account_number_not_matching = true;
                    }else{
                        this.reentered_account_number_not_matching = false;
                        this.account_number_not_matching = false;
                    }
                } else if(this.reenter_account_number != "") {
                    this.validate_reentered_account_number = true;
                    this.reentered_account_number_not_matching = false;
                }
            }
        },

        setIFSC(value){
            if(value.trim()){
                // this.ifsc = value.trim();
                this.$v.ifsc.$touch();
                let letters = /^([a-zA-Z0-9]{11,11})$/
                if(this.ifsc.match(letters)) {
                    this.validate_ifsc = false;
                } else if(this.ifsc != "") {
                    this.validate_ifsc = true;
                }
            }else{
                this.validate_ifsc = true;
            }
        },

        setBankName(value){
            if(value.trim()){
                // this.bank_name = value.trim();
                this.$v.bank_name.$touch();
                var letters = /^[A-Za-z_ ]+$/;
                if(this.bank_name.match(letters)) {
                    this.validate_bank_name = false;
                } else if(this.bank_name != "") {
                    this.validate_bank_name = true;
                }
            }else{
                this.validate_bank_name = true;
            }
        },

        setBeneficiaryName(value){
            if(value.trim()){
                // this.bank_name = value.trim();
                this.$v.beneficiary_name.$touch();
                var letters = /^[A-Za-z_ ]+$/;
                if(this.beneficiary_name.match(letters)) {
                    this.validate_beneficiary_name = false;
                } else if(this.beneficiary_name != "") {
                    this.validate_beneficiary_name = true;
                }
            }else{
                this.validate_beneficiary_name = true;
            }
        },

        setMobileNumber(value){
            if(value){
                this.mobile_number = value.trim();
                this.$v.mobile_number.$touch();

                var letters = /^([0-9]{10,10})$/;

                if(this.mobile_number.match(letters)) {
                    this.validate_mobile_number = false;
                } else if(this.mobile_number != "") {
                    this.validate_mobile_number = true;
                }
            }
        },

        saveBilingDetails(){
            if((this.account_number.trim() && !this.validate_account_number && !this.account_number_not_matching) && (this.reenter_account_number.trim() && !this.validate_reentered_account_number && !this.reentered_account_number_not_matching) && (this.ifsc.trim() && !this.validate_ifsc) && (this.bank_name.trim() && !this.validate_bank_name) && (this.beneficiary_name.trim() && !this.validate_beneficiary_name) && (this.mobile_number.trim() && !this.validate_mobile_number)){

                this.save();
            }else{

                new CripNotice({
                    title: "Oops! Something went wrong!",
                    description: 'Please fill all required details',
                    type: "error",
                    duration: 3,
                });
            }
        },

        // api to sav bank details
        save(){
            this.is_bank_details_save_progress = true;     //enabled loader

            serverAddr
            .post("/efs/fill_bank_info", {
                account_number: this.account_number,
                ifsc_code: this.ifsc,
                bank_name: this.bank_name,
                beneficiary_name: this.beneficiary_name,
                mobile: this.mobile_number
            })
            .then(response => {
                if(response.data.status){
                    // store billing details in store
                    let obj = {
                        account_number: this.account_number,
                        ifsc: this.ifsc,
                        bank_name: this.bank_name,
                        beneficiary_name: this.beneficiary_name,
                        mobile_number: this.mobile_number
                    };

                    new CripNotice({
                        title: "Success",
                        description: 'Updated billing details',
                        type: "success",
                        duration: 3,
                    });

                    this.$store.commit('commitBillingDetails', obj);
                }
                this.is_bank_details_save_progress = false;     //disabled loader
            })
            .catch(
                function(error) {
                    console.log(error);
                    this.is_bank_details_save_progress = false;     //disabled loader
                }.bind(this)
            );
        },

        getBankDetailsNetworkCallBack(){
            this.is_bank_details_loading = true;     //enabled loader

            serverAddr
            .get("/efs/get_bank_info")
            .then(response => {
                if(response.data.status){
                    let bank_details = response.data.data;

                    // store bank details in store
                    let obj = {
                        account_number: bank_details.account_number,
                        reenter_account_number: bank_details.account_number,
                        ifsc: bank_details.ifsc_code,
                        bank_name: bank_details.bank_name,
                        beneficiary_name: bank_details.beneficiary_name,
                        mobile_number: bank_details.mobile
                    };

                    this.account_number = bank_details.account_number ? bank_details.account_number : '';
                    this.reenter_account_number = bank_details.account_number ? bank_details.account_number : '';
                    this.ifsc = bank_details.ifsc_code ? bank_details.ifsc_code: '';
                    this.bank_name = bank_details.bank_name ? bank_details.bank_name : '';
                    this.beneficiary_name = bank_details.beneficiary_name ? bank_details.beneficiary_name : '';
                    this.mobile_number = bank_details.mobile ? bank_details.mobile : '';

                    this.$store.commit('commitBankDetails', obj);
                }
                this.is_bank_details_loading = false;     //disabled loader
            })
            .catch(
                function(error) {
                    console.log(error);
                    this.is_bank_details_loading = false;     //disabled loader
                }.bind(this)
            );
        }
    },

    computed: {
        getBankDetails(){
            return this.$store.state.bank_details;
        }
    }
}
</script>
<style lang="scss" scoped>
@import "../css/variable.scss";
@import "../css/common.scss";
</style>

<style lang="scss">
@import "../css/variable.scss";
@import "../css/common.scss";

.BankDetails{
    .el-button--primary.is-disabled {
        color: #FFF;
        background-color: #a0cfff;
        border-color: #a0cfff;
    }
    .el-button--primary.is-disabled {
        color: #FFF;
        background-color: #a0cfff;
        border-color: #a0cfff;
    }
}
</style>
